// extracted by mini-css-extract-plugin
export default {"Description":"CheckboxConfig_Description__aIiwi","CheckboxField":"CheckboxConfig_CheckboxField__rEEBb"};